var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_303_1281)",
    filter: "url(#filter0_d_303_1281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.42065 17.0159C4.42065 15.4246 5.0528 13.8985 6.17801 12.7733C7.30323 11.6481 8.82936 11.0159 10.4207 11.0159C12.012 11.0159 13.5381 11.6481 14.6633 12.7733C15.7885 13.8985 16.4207 15.4246 16.4207 17.0159H14.9207C14.9207 15.8225 14.4465 14.6779 13.6026 13.8339C12.7587 12.99 11.6141 12.5159 10.4207 12.5159C9.22718 12.5159 8.08259 12.99 7.23867 13.8339C6.39476 14.6779 5.92065 15.8225 5.92065 17.0159H4.42065ZM10.4207 10.2659C7.9344 10.2659 5.92065 8.25218 5.92065 5.76593C5.92065 3.27968 7.9344 1.26593 10.4207 1.26593C12.9069 1.26593 14.9207 3.27968 14.9207 5.76593C14.9207 8.25218 12.9069 10.2659 10.4207 10.2659ZM10.4207 8.76593C12.0782 8.76593 13.4207 7.42343 13.4207 5.76593C13.4207 4.10843 12.0782 2.76593 10.4207 2.76593C8.76315 2.76593 7.42065 4.10843 7.42065 5.76593C7.42065 7.42343 8.76315 8.76593 10.4207 8.76593ZM16.6337 11.5432C17.6877 12.0179 18.5821 12.7869 19.2096 13.7577C19.837 14.7286 20.1708 15.86 20.1707 17.0159H18.6707C18.6708 16.1489 18.4206 15.3003 17.95 14.5721C17.4794 13.8439 16.8085 13.2672 16.0179 12.9112L16.6329 11.5432H16.6337ZM16.1177 3.07568C16.8733 3.38715 17.5194 3.91608 17.9739 4.59535C18.4285 5.27462 18.671 6.07361 18.6707 6.89093C18.671 7.92018 18.2864 8.91235 17.5926 9.67255C16.8987 10.4327 15.9457 10.906 14.9207 10.9994V9.48968C15.4764 9.41009 15.9919 9.15444 16.3916 8.76027C16.7914 8.3661 17.0542 7.85417 17.1415 7.29963C17.2289 6.74509 17.1361 6.17715 16.8769 5.6792C16.6177 5.18124 16.2057 4.77949 15.7014 4.53293L16.1177 3.07568Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_303_1281",
    x: -1.07935,
    y: 0.51593,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_303_1281"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_303_1281",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_303_1281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(2.92065 0.51593)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/customers.31fd9254c7e275349407af37cb8e0157.svg";
export { ForwardRef as ReactComponent };